import {
  Flex,
  Text,
  useColorModeValue,
  SimpleGrid,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  IconButton,
  Button,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import IconBox from "components/icons/IconBox";
import { LuInfo } from "react-icons/lu";
import {
  convertDateToFormattedString,
  formatCurrencyFloor,
} from "config/functions";
import { useState } from "react";
import {
  MdOutlineAccessTime,
  MdCancel,
  MdOutlineSwitchAccessShortcutAdd,
  MdOutlineDoNotDisturbOnTotalSilence,
  MdOutlineLocationOn,
  MdOutlinePriceCheck,
  MdAttachMoney,
  MdOutlineGroupAdd,
  MdTransferWithinAStation,
  MdMobiledataOff,
  MdAddCard,
  MdQrCode,
} from "react-icons/md";
import MapCard from "views/admin/atendimento/profile/components/MapCard";

export default function Transaction(props: { extrato: any }) {
  const { extrato, ...rest } = props;

  const textColor = useColorModeValue("secondaryGray.900", "brand.200");
  const iconBoxBg = useColorModeValue("secondaryGray.300", "brand.200");
  const textRedBg = useColorModeValue("red.600", "red.300");
  const textVerdeBg = useColorModeValue("green.600", "green.300");
  const textBlueBg = useColorModeValue("blue.600", "blue.300");
  const textBg = useColorModeValue("brand", "brand.200");
  const [pedidoModal, setPedidoModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const buttonColor = useColorModeValue("brand.500", "white");
  const textButtonColor = useColorModeValue("white", "brand.200");

  const onChangeModalOpen = () => {
    const fotoElementoUsuario = document.getElementById("fotoElementoUsuario");
    const fotoElementoUsuario2 = document.getElementById(
      "fotoElementoUsuario2"
    );

    if (fotoElementoUsuario) fotoElementoUsuario.style.display = "none";
    if (fotoElementoUsuario2) fotoElementoUsuario2.style.display = "none";

    setPedidoModal(true);
  };

  const mostrarInfor = () => {
    const fotoElementoUsuario = document.getElementById("fotoElementoUsuario");
    const fotoElementoUsuario2 = document.getElementById(
      "fotoElementoUsuario2"
    );

    if (fotoElementoUsuario) fotoElementoUsuario.style.display = "none";
    if (fotoElementoUsuario2) fotoElementoUsuario2.style.display = "none";
    setInfoModal(true);
  };

  const onChangeModalClose = () => {
    const fotoElementoUsuario = document.getElementById("fotoElementoUsuario");
    const fotoElementoUsuario2 = document.getElementById(
      "fotoElementoUsuario2"
    );

    if (fotoElementoUsuario) fotoElementoUsuario.style.display = "block";
    if (fotoElementoUsuario2) fotoElementoUsuario2.style.display = "block";

    setPedidoModal(false);
  };

  const onChangeInforClose = () => {
    const fotoElementoUsuario = document.getElementById("fotoElementoUsuario");
    const fotoElementoUsuario2 = document.getElementById(
      "fotoElementoUsuario2"
    );

    if (fotoElementoUsuario) fotoElementoUsuario.style.display = "block";
    if (fotoElementoUsuario2) fotoElementoUsuario2.style.display = "block";

    setInfoModal(false);
  };

  const statusIcon = (status: any, tipoUtilizacao: any) => {
    switch (status) {
      case "DEBITO": // debito
        return (
          <Icon
            as={MdOutlineDoNotDisturbOnTotalSilence}
            color={textRedBg}
            w="22px"
            h="22px"
          />
        );
      case "Crédito em conta Jaé": // credito
        return (
          <Icon as={MdAttachMoney} color={textVerdeBg} w="22px" h="22px" />
        );
      case "Crédito em conta Jaé VT": // credito
        return (
          <Icon as={MdAttachMoney} color={textVerdeBg} w="22px" h="22px" />
        );
      case "Cancelamento": // cancelamento
        return <Icon as={MdCancel} color={textRedBg} w="22px" h="22px" />;

      case "Bloqueio Saldo": // cancelamento
        return <Icon as={MdCancel} color={textRedBg} w="22px" h="22px" />;

      case "Desbloqueio Saldo": // cancelamento
        return (
          <Icon as={MdAttachMoney} color={textVerdeBg} w="22px" h="22px" />
        );

      case "GRATUIDADE": // Gratuidades
        return (
          <Icon as={MdOutlineGroupAdd} color={"yellow.500"} w="22px" h="22px" />
        );
      case "ACOMPANHANTE": // transferência
        return (
          <Icon as={MdOutlineGroupAdd} color={"yellow.700"} w="22px" h="22px" />
        );
      case "Transferência de crédito": // transferência
        return (
          <Icon
            as={MdMobiledataOff}
            color={tipoUtilizacao === 2 ? textVerdeBg : textRedBg}
            w="22px"
            h="22px"
          />
        );

      case "INTEGRACAO": // Integração
        return (
          <Icon
            as={MdOutlineSwitchAccessShortcutAdd}
            color={"blue.600"}
            w="22px"
            h="22px"
          />
        );
      case "TRANSFERENCIA": // transferência
        return (
          <Icon
            as={MdTransferWithinAStation}
            color={"blue.600"}
            w="22px"
            h="22px"
          />
        );

      default:
        return (
          <Icon
            as={MdOutlinePriceCheck}
            color={textVerdeBg}
            w="22px"
            h="18px"
          />
        );
    }
  };

  const statusTipoMovimento = (status: any, tipoUtilizacao: any) => {
    switch (status) {
      case "DEBITO":
        return (
          <Text
            ms="auto"
            color={textRedBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Débito
          </Text>
        );
      case "Bloqueio saldo":
        return (
          <Text
            ms="auto"
            color={textRedBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Bloqueio de saldo
          </Text>
        );
      case "CREDITO":
        return (
          <Text
            ms="auto"
            color={textVerdeBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Crédito em conta
          </Text>
        );
      case "Crédito em conta Jaé VT":
        return (
          <Text
            ms="auto"
            color={textVerdeBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Crédito em conta Jaé VT
          </Text>
        );
      case "Desbloqueio saldo":
        return (
          <Text
            ms="auto"
            color={textVerdeBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Saldo desbloqueado
          </Text>
        );
      case "Crédito em conta Jaé":
        return (
          <Text
            ms="auto"
            color={textVerdeBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Crédito em conta Jaé
          </Text>
        );
      case "Crédito em conta":
        return (
          <Text
            ms="auto"
            color={textVerdeBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Crédito em conta
          </Text>
        );

      case "CANCELAMENTO":
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Cancelamento
          </Text>
        );
      case "TRANSFERENCIA":
        return (
          <Text
            ms="auto"
            color={"blue.600"}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Transferência
          </Text>
        );
      case "GRATUIDADE":
        return (
          <Text
            ms="auto"
            color={"yellow.500"}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Gratuidade
          </Text>
        );
      case "ACOMPANHANTE":
        return (
          <Text
            ms="auto"
            color={"yellow.700"}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Gratuidade acompanhante
          </Text>
        );
      case "INTEGRACAO":
        return (
          <Text
            ms="auto"
            color={textBlueBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Integração
          </Text>
        );
      case "BLOQUEIO":
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Bloqueio
          </Text>
        );
      case "Bloqueio Saldo":
        return (
          <Text
            ms="auto"
            color={textBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Bloqueio saldo
          </Text>
        );
      case "Transferência de crédito": // transferência
        return (
          <Text
            ms="auto"
            color={tipoUtilizacao === 2 ? textVerdeBg : textRedBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            Transferência {tipoUtilizacao === 1 ? "para" : "de"}{" "}
            {extrato?.nomeClienteDestino}
          </Text>
        );
      default:
        return (
          <Text
            ms="auto"
            color={tipoUtilizacao === 2 ? textVerdeBg : textRedBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            {status}
          </Text>
        );
    }
  };

  const statusTipoMidia = (status: any) => {
    switch (status) {
      case 1:
        return <Icon as={MdAddCard} color={textColor} w="22px" h="22px" />;
      case 4:
        return <Icon as={MdAddCard} color={textColor} w="22px" h="22px" />;
      case 2:
        return <Icon as={MdQrCode} color={textColor} w="22px" h="22px" />;

      case 3:
        return (
          <Text
            color={textColor}
            fontSize="sm"
            me="6px"
            fontWeight="700"
            ml="5px"
          >
            NFC
          </Text>
        );
    }
  };

  const tipoValor = (status: any, valor: any) => {
    switch (status) {
      case 4:
      case 2:
        return (
          <Text
            ms="auto"
            color={textVerdeBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            {formatCurrencyFloor(valor)}
          </Text>
        );
      case 1:
        return (
          <Text
            ms="auto"
            color={valor === 0 ? textBlueBg : textRedBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            {formatCurrencyFloor(valor)}
          </Text>
        );
      default:
        return (
          <Text
            ms="auto"
            color={textBlueBg}
            fontSize="medium"
            fontWeight="600"
            mr="10px"
          >
            {formatCurrencyFloor(valor)}
          </Text>
        );
    }
  };

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      w="100%"
      mt="20px"
      {...rest}
    >
      {extrato?.nomeClienteDestino !== "Jaé1" && (
        <>
          <IconBox
            h="42px"
            w="42px"
            bg={iconBoxBg}
            me="20px"
            mb="15px"
            mr="15px"
            icon={statusIcon(extrato?.tipoMovimento, extrato?.tipoUtilizacao)}
          />
          <Flex
            direction={{ base: "column", sm: "row" }}
            align={{ base: "start", sm: "center" }}
            me="auto"
            mb="15px"
            justifyItems="center"
            w="100%"
          >
            <Flex direction="column" align="start" me="auto">
              <Text color={textColor} fontSize="md" me="0px" fontWeight="700">
                <Flex direction="row" align="start" me="-20px" mt="5px">
                  {statusTipoMovimento(
                    extrato?.tipoMovimento,
                    extrato?.tipoUtilizacao
                  )}
                  {statusTipoMidia(extrato?.idTipoMidia)}
                </Flex>
              </Text>
              {extrato?.numeroLinha && (
                <Text fontSize="small" fontWeight="500">
                  <b>Linha:</b> {extrato?.numeroLinha} -{" "}
                  {extrato?.descricaoLinha || extrato?.nomeLinha}
                </Text>
              )}
              {extrato?.numeroSerieValidador && (
                <Text fontSize="small" fontWeight="500">
                  <b>Validador:</b> {extrato?.numeroSerieValidador}
                </Text>
              )}
              {extrato?.processamentoEmAtraso == true ? (
                <>
                  <Text color={textBg} fontSize="small" fontWeight="500">
                    <b>Data embarque:</b>{" "}
                    {convertDateToFormattedString(
                      extrato?.dataTransacao || extrato?.data
                    )}
                  </Text>

                  <Flex
                    flexDirection="row"
                    alignItems="center"
                    alignContent="center"
                    alignSelf="flex-start"
                    wrap="wrap"
                  >
                    <Text color="orange.700" fontSize="small" fontWeight="500">
                      <b>Processamento com atraso:</b>
                    </Text>
                    <Text fontSize="small" fontWeight="500" ml="4px">
                      {convertDateToFormattedString(extrato?.dataProcessamento)}
                    </Text>
                    <IconButton
                      aria-label="Search database"
                      color={"orange.700"}
                      size={"xs"}
                      ml={"5px"}
                      onClick={() => mostrarInfor()}
                    >
                      <LuInfo size={"lg"} />
                    </IconButton>
                  </Flex>
                </>
              ) : (
                <Text color={textBg} fontSize="small" fontWeight="500">
                  <b>Data:</b>{" "}
                  {convertDateToFormattedString(
                    extrato?.dataTransacao || extrato?.data
                  )}
                </Text>
              )}
            </Flex>
            <Flex
              direction="row"
              align={{ base: "center", sm: "flex-end" }}
              justify={{ base: "flex-end", sm: "flex-end" }}
              mt={{ base: "10px", sm: "0px" }}
              ml={{ base: "auto", sm: "15px" }}
              minW="fit-content"
            >
              <SimpleGrid
                columns={1}
                spacing={1}
                justifyItems="flex-end"
                alignContent="flex-end"
              >
                {tipoValor(
                  extrato?.tipoUtilizacao,
                  extrato?.valorTransacao || extrato?.valorLancamento
                )}
                {extrato?.latitude ? (
                  <IconButton
                    aria-label="Location"
                    variant="ghost"
                    size="sm"
                    mt="5px"
                    icon={
                      <Icon
                        as={MdOutlineLocationOn}
                        width="24px"
                        height="24px"
                        color={textColor}
                        onClick={onChangeModalOpen}
                      />
                    }
                  />
                ) : null}
              </SimpleGrid>
            </Flex>
          </Flex>
          <Modal
            isOpen={pedidoModal}
            onClose={onChangeModalClose}
            size={{ base: "full", md: "md" }}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Informações de embarque:</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Card justifyContent="center" flexDirection="row">
                  <MapCard
                    latitude={extrato?.latitude}
                    longitude={extrato?.longitude}
                    valor={tipoValor(
                      extrato?.tipoUtilizacao,
                      extrato?.valorTransacao || extrato?.valorLancamento
                    )}
                    data={extrato?.dataTransacao || extrato?.data}
                    nomeLinha={extrato?.nomeLinha || extrato?.descricaoLinha}
                    numeroLinha={extrato?.numeroLinha}
                    numeroValidador={extrato?.numeroSerieValidador}
                  />
                </Card>
              </ModalBody>
              <ModalFooter alignSelf="center"></ModalFooter>
            </ModalContent>
          </Modal>
          <Modal
            isOpen={infoModal}
            onClose={onChangeInforClose}
            size={{ base: "full", md: "md" }}
            isCentered
          >
            <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
            <ModalContent borderRadius="2xl" overflow="hidden" boxShadow="lg">
              <ModalHeader
                bg="orange.50"
                color="orange.700"
                fontWeight="700"
                textAlign="center"
                fontSize="xl"
                py={4}
              >
                Processamento com atraso
              </ModalHeader>
              <ModalCloseButton color="gray.500" />
              <ModalBody py={8} px={6}>
                <Flex
                  direction="column"
                  align="center"
                  textAlign="center"
                  gap={4}
                >
                  <Icon
                    as={MdOutlineAccessTime}
                    w={10}
                    h={10}
                    color="orange.400"
                  />
                  <Text fontSize="md" color={textColor} lineHeight="1.6">
                    O processamento desta transação foi realizado com atraso.
                    <br />
                    <br />
                    Por causa disso, o valor foi debitado
                    <Text as="span" fontWeight="600" color="orange.600">
                      {" "}
                      após a data de embarque{" "}
                    </Text>
                    da conta do cliente.
                  </Text>
                </Flex>
              </ModalBody>
              <ModalFooter justifyContent="center">
                <Button
                  onClick={onChangeInforClose}
                  bgColor={buttonColor}
                  color={textButtonColor}
                  _hover={{ bgColor: "teal.700" }}
                >
                  Entendi
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
      )}
    </Flex>
  );
}
